import { render } from "./HomeLayout.vue?vue&type=template&id=3df0563e&scoped=true&ts=true"
import script from "./HomeLayout.vue?vue&type=script&lang=ts"
export * from "./HomeLayout.vue?vue&type=script&lang=ts"

import "./HomeLayout.vue?vue&type=style&index=0&id=3df0563e&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df0563e"]])

export default __exports__